import React from "react";
import PublicPageLayout from "./PublicPageLayout";

const scenarios = [
  ["單點運輸", "適合起點到終點的鋼材、設備、建材與大型貨物運輸。"],
  ["多點配送", "依照配送站、貨物與收件者整理工作，讓司機依序完成每一站。"],
  ["車隊協作", "讓管理者與司機共享必要資訊，減少重複確認與分散訊息。"],
];

export default function Scenarios() {
  return (
    <PublicPageLayout
      title="應用情境"
      intro="從一趟單點運輸，到多站配送與車隊協作，Tallarge 可以配合不同的工作方式。"
    >
      <div className="public-page-grid">
        {scenarios.map(([title, text]) => (
          <article className="public-page-card" key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </PublicPageLayout>
  );
}
